"use strict";
import Vue from "vue";
import { _axios } from "../plugins/axios";
import { signData } from "./bridge";
import qs from "qs";
const Request = {};

export async function request(params) {
    const options = {
        method: "post",
        responseType: "json"
    };
    Object.assign(options, params);
    try {
        return (await _axios(options)).data;
    } catch (e) {
        return Promise.reject(e);
    }
}

export async function requestTM(params) {
    const options = {
        method: "post",
        responseType: "json"
    };
    Object.assign(options, params);
    options.data = qs.stringify({
        data: JSON.stringify({
            appReqData: options.data
        })
    });
    try {
        return (await request(options));
    } catch (e) {
        return Promise.reject(e);
    }
}
export async function requestToken(params, isEncrypt) {
    const options = {
        method: "post",
        responseType: "json"
    };
    Object.assign(options, params);
    const signResStr = await signData(options.data, isEncrypt);
    options.data = qs.stringify({
        data: signResStr
    });
    try {
        return (await request(options));
    } catch (e) {
        return Promise.reject(e);
    }
}
//统一拦截所有的ajax
function intercept(fn) {
    return async function() {
        return await fn.apply(this, arguments).then(res => {
            const { code, msg } = res;
            if (Number(code) !== 1) {
                return Promise.reject(msg);
            }
            return res;
        });
    };
}
Request.install = function(Vue) {
    Vue.$request = intercept(request);
    Vue.$requestTM = intercept(requestTM);
    Vue.$requestToken = intercept(requestToken);
    Object.defineProperties(Vue.prototype, {
        $request: {
            get() {
                return intercept(request);
            }
        },
        $requestTM: {
            get() {
                return intercept(requestTM);
            }
        },
        $requestToken: {
            get() {
                return intercept(requestToken);
            }
        }
    });
};

export default Request;
